$(document).ready(function () {
  $("#grid-view").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    $(".product--card")
      .addClass("grid-view-product")
      .removeClass("list-view-product")
      .removeClass("table-view-product");
  });

  $("#list-view").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    $(".product--card")
      .addClass("list-view-product")
      .removeClass("grid-view-product")
      .removeClass("table-view-product");
  });
  $("#table-view").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    $(".product--card")
      .addClass("table-view-product")
      .removeClass("list-view-product")
      .removeClass("grid-view-product");
  });
});
